// eslint-disable-next-line import/prefer-default-export
export function deepFreeze(obj) {
  if (!obj || typeof obj !== 'object') return obj;
  Object.keys(obj).forEach((prop) => {
    if (typeof obj[prop] === 'object' && !Object.isFrozen(obj[prop])) deepFreeze(obj[prop]);
  });
  return Object.freeze(obj);
}
